import { IReducerAction } from '../../../../Hooks/Context/connect';

import { IAuthPartialReducer, TAuthPartialState } from './Reducers';

enum Types {
    FB_CONSENT = 'LOGIN:FB_CONSENT',
    FBSDK_LOADED = 'LOGIN:FBSDK_LOADED',
    FORGOT_PASSWORD = 'LOGIN:FORGOT_PASSWORD',
    FB_TOKEN_CHANGED = 'LOGIN:FB_TOKEN_CHANGED',
    CHANGE_FB_BUTTON_STATE = 'LOGIN:CHANGE_FB_BUTTON_STATE',
    FB_CONSENT_MODAL_STATUS = 'LOGIN:FB_CONSENT_MODAL_STATUS',
    CHANGE_FORGOT_PASSWORD_STATE = 'LOGIN:CHANGE_FORGOT_PASSWORD_STATE',
}

interface IAuthStateLogin extends TAuthPartialState {
    facebookSDK: object,
    fbAccessToken: string | null,
    forgotPassword: boolean,
    fbShowConsentModal: boolean,
    consentSubscription: boolean,

    fbButtonState: {
        loading: boolean,
        btnDisabled: boolean,
        fbEmailForbidden: boolean,
    },

    forgotPasswordState: {
        email: string,
        error: string,
        success: string,
        loading: boolean,
        btnDisabled: boolean,
        showFacebookMessage: boolean,
    },
}

interface IAuthLoginReducer extends IAuthPartialReducer {
    (action: IReducerAction, state: { Login: IAuthStateLogin }): void;
}

const initialState: { Login: IAuthStateLogin } = {
    Login: {
        facebookSDK: {},
        fbAccessToken: null,
        forgotPassword: false,
        fbShowConsentModal: false,
        consentSubscription: false,

        fbButtonState: {
            loading: false,
            btnDisabled: true,
            fbEmailForbidden: false
        },

        forgotPasswordState: {
            email: '',
            error: '',
            success: '',
            loading: false,
            btnDisabled: false,
            showFacebookMessage: false
        }
    }
};

const LoginReducer: IAuthLoginReducer = (action, state = initialState) => {
    switch (action.type) {
        case Types.FBSDK_LOADED:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    facebookSDK: action.data
                }
            };

        case Types.FORGOT_PASSWORD:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    forgotPassword: action.data.open,
                    forgotPasswordState: {
                        ...state.Login.forgotPasswordState,
                        showFacebookMessage: action.data.showFacebookMessage
                    }
                }
            };

        case Types.FB_CONSENT_MODAL_STATUS:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    fbShowConsentModal: action.data
                }
            };

        case Types.FB_CONSENT:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    consentSubscription: action.data
                }
            };

        case Types.FB_TOKEN_CHANGED:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    fbShowConsentModal: true,
                    fbAccessToken: action.data
                }
            };

        case Types.CHANGE_FB_BUTTON_STATE:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    fbButtonState: {
                        ...state.Login.fbButtonState,
                        ...action.data
                    }
                }
            };

        case Types.CHANGE_FORGOT_PASSWORD_STATE:
            return {
                ...state,
                Login: {
                    ...state.Login,
                    forgotPasswordState: {
                        ...state.Login.forgotPasswordState,
                        ...action.data
                    }
                }
            };

        default:
            return state;
    }
};

export {
    initialState,

    Types,
    IAuthLoginReducer,
    IAuthStateLogin
};

export default LoginReducer;
